export const REQUEST = 'Survey/Analysis/REQUEST';
export const SUCCESS = 'Survey/Analysis/SUCCESS';
export const ERROR = 'Survey/Analysis/ERROR';
